exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lazy-image-placeholder{background-position:50%;background-repeat:no-repeat;background-size:auto}.lazy-image{max-width:100%!important}", ""]);

// exports
